import { useEffect, useState } from "react";
import { useNavigation, useRevalidator } from "react-router-dom";

import { cn } from "@/lib/utils";

/**
 * Thin animated bar pinned to the top of the dashboard. Lights up when
 * react-router is *loading* / *submitting* a navigation, or when a
 * revalidation is running (e.g. after switching team).
 *
 * Renders nothing during idle navigation so it stays out of the way.
 * Adds a 120ms delay before showing the bar so flick-fast loaders
 * don't flash a bar that disappears instantly.
 */
export function TopProgress() {
  const navigation = useNavigation();
  const revalidator = useRevalidator();
  const busy = navigation.state !== "idle" || revalidator.state !== "idle";
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!busy) {
      setVisible(false);
      return;
    }
    const timer = window.setTimeout(() => setVisible(true), 120);
    return () => window.clearTimeout(timer);
  }, [busy]);

  return (
    <div
      aria-hidden={!visible}
      className={cn(
        "pointer-events-none fixed left-0 right-0 top-0 z-50 h-0.5 overflow-hidden",
        "transition-opacity duration-150",
        visible ? "opacity-100" : "opacity-0",
      )}
    >
      <div className="h-full w-1/3 animate-top-progress bg-primary/80" />
    </div>
  );
}
